module.exports = {"532929101":"诺邓镇","532929102":"功果桥镇","532929103":"漕涧镇","532929104":"白石镇","532929201":"宝丰乡","532929202":"关坪乡","532929203":"团结彝族乡","532929204":"长新乡","532929205":"检槽乡","532929206":"苗尾傈僳族乡","532929207":"民建乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532929.json
// module id = 2656
// module chunks = 0